/***************************************************
Root Reducer
****************************************************/
import { FETCH_WEATHER, SET_WEATHER_TIME, SET_LOCAL_WEATHER_SITE,
 SET_WEATHER_LOCATION } from './types';
import { TIME } from './constants';
import { swapKeyWithValue } from './utils';
const initState = {
  locations: {
    all: [],
    displaying: []
  },
  view: {
    lastUpdated: '',
    date: '',
    time: '06',
    loc: 1,
    location: 71,
    name: 'Husking',
    datapoint: {
      airQuality: {},
      weather: {}
    },
    dataset: {
      airQuality: [],
      weather: []
    }
  }
};

export default function WeatherReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_WEATHER:
      if (action.payload.length === 0) return state;
      let loc = action.payload.find((l) => l.name === initState.view.name);
      if (loc.airQuality.length === 0 && loc.weather.length === 0) return state;
      let hour = loc.airQuality[loc.airQuality.length - 1].observation_time.split(' ')[1].split(':')[0]  || 'N/A';
      if (document.getElementById('weather-time')) document.getElementById('weather-time').value = swapKeyWithValue(TIME)[hour];

      let lastUpdated = state.view.lastUpdated;
      if (lastUpdated === '') lastUpdated = loc.airQuality[loc.airQuality.length - 1].observation_time;
      return { ...state,
        locations: { ...state.locations,
          all: action.payload,
          displaying: action.payload.filter((l) => l.loc === state.view.location)
        },
        view: { ...state.view,
          date: action.date,
          lastUpdated,
          time: hour,
          datapoint: { ...loc,
            airQuality: loc.airQuality[loc.airQuality.length - 1] || {},
            weather: loc.weather[loc.weather.length - 1] || {}
          },
          dataset: {
            airQuality: loc.airQuality,
            weather: loc.weather
          }
        }
      }
    case SET_WEATHER_TIME:
      return { ...state,
        view: { ...state.view,
          time: action.payload,
          datapoint: action.loc,
          name: action.loc.name,
          dataset: action.dataset
        }
      };
    case SET_LOCAL_WEATHER_SITE:
      return { ...state,
        view: { ...state.view,
          datapoint: action.payload,
          name: action.payload.name,
          loc: action.payload.id,
          dataset: action.dataset
        }
      };
    case SET_WEATHER_LOCATION:
      let locs = state.locations.all.filter((l) => l.loc === Number(action.payload));
      let record = locs[0];
      let _hour = record.airQuality[record.airQuality.length - 1].observation_time.split(' ')[1].split(':')[0]  || 'N/A';
      document.getElementById('weather-time').value = swapKeyWithValue(TIME)[_hour];
      document.getElementById('weather-location').value = record.id;
      return { ...state,
        locations: { ...state.locations,
          displaying: locs
        },
        view: { ...state.view,
          time: _hour,
          loc: record.id,
          location: Number(action.payload),
          name: record.name,
          datapoint: { ...record,
            airQuality: record.airQuality[record.airQuality.length - 1],
            weather: record.weather[record.weather.length - 1]
          },
          dataset: {
            airQuality: record.airQuality,
            weather: record.weather
          }
        }
      };
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/weather/reducer.js